/* eslint-disable no-trailing-spaces */
import React, { useContext, useState, useEffect } from "react";

import Masonry from '@mui/lab/Masonry'

import OwlCarousel from 'react-owl-carousel3';

import { getFromApi } from '../../lib/js/api'


function MarketPage(props) {

  const [domain, setDomain] = useState(null)
  const [market, setMarket] = useState(null)
  const [businesses, setBusinesses] = useState([])
  const [category, setCategory] = useState(null)
  const [section, setSection] = useState(null)
  const [term, setTerm] = useState(null)
  const [categories, setCategories] = useState([])
  const [sections, setSections] = useState([])
  const [products, setProducts] = useState([])

  useEffect(() => {

    // console.log(window.business)
    //console.log(window.entries)

    let business = window.business
    setMarket(business)

    setBusinesses(window.entries)

    // get the list of sections and categories
    let sections = {}
    let categories = {}
    window.entries.forEach((b) => {
      sections[b.section] = true
      categories[b.category] = true
    })

    setSections(Object.keys(sections).sort())
    setCategories(Object.keys(categories).sort())

    if (business) {

      // get the products for the businesses in the market
      let path = `/api/v1/business/market/${business.id}/products`

      getFromApi(
        path, {}, (response) => {
          //console.log("got products", response.result)
          let products = response.result

          setProducts(products)
        }, (error) => {
          console.log("Error", error)
        }
      )

      setDomain(business.uuid.toLowerCase())

      let css = document.createElement('style');

      css.innerHTML = `
      body {
        background-color: #000000;
        color: #ffffff;
      }
  .home-container {
        background-color: #000000;
        color: #ffffff;
      }
    `;

      if (business.style && business.style != "") {
        css.innerHTML = business.style
      } else if (business.colour && business.colour != "") {
        let style = {
          backgroundColor: _prefixedColour(business.colour),
          color: invertColor(business.colour, true)
        }
        css.innerHTML = `
        body {
          background-color: ${style.backgroundColor};
          color: ${style.color};
        }
        .home-container {
      background-color: ${style.backgroundColor};
      color: ${style.color};
    }
    .home-container .social-button i {
      color: ${style.color};
    }
  `;
      }

      //console.log("style", css.innerHTML)

      document.head.appendChild(css);

    }

  }, [])

  const filterBusinesses = (businesses) => {
    let entries = businesses

    // select by section first
    if (section != null && section != "") {
      //console.log("filter for section", section)
      entries = entries.filter((b) => b.section == section)
    }

    // then category
    if (category != null && category != "") {
      //console.log("filter for category", category)
      entries = entries.filter((b) => b.category == category)
    }

    // finally search business name, description, products
    if (term != null && term != "" && term.length >= 3) {
      //console.log("filter for search term", term)

      if (businesses.length > 0) {
        if (!businesses[0].lowerName) {
          //console.log("lower casing businesses")
          businesses.forEach((b) => {
            b.lowerName = b.name.toLowerCase()
            b.lowerDescription = b.description.toLowerCase()
          })
        }
      }

      let res = entries.filter((b) => b.lowerName.includes(term) || b.lowerDescription.includes(term))

      // if entries are empty search products
      if (res.length == 0) {
        // ensure product names and description are lowercased
        if (products.length > 0) {
          if (!products[0].lowerName) {
            //console.log("lower casing products")
            products.forEach((p) => {
              p.lowerName = p.name.toLowerCase()
              p.lowerDescription = p.description.toLowerCase()
            })
          }
        }
        let matching = products.filter((p) => p.lowerName.includes(term) || p.lowerDescription.includes(term))

        // now find the entries with products that match
        // convert product list to a list of business IDs
        let ids = [...new Set(matching.map((p) => p.businessId))]

        entries = entries.filter((b) => ids.includes(b.businessId))


      } else {
        entries = res
      }
    }
    return entries
  }

  const _getMasonryGrid = (businesses) => {

    let entries = filterBusinesses(businesses)

    return <div style={{
      marginLeft: 10
    }}>
      <Masonry columns={{ xs: 2, sm: 3, md: 4, lg:5, xl:6}} spacing={2}>
    {entries.map((business, index) => (
      <div className="card card-business online" key={'mktbiz_'+index}
      onClick={() => {
        //console.log("clicked", business)
        onSelected(business)
      }}
    >
      <img className="card-img-top" src={business.photo} alt="Card image cap" />
      <div className="card-body">
        <h1 className="card-name"> {business.name} </h1>
      </div>
    </div>
    ))}
  </Masonry>
    </div>
  }

  const onSelected = (business) => {
    let domain = business.uuid
    let url = `https://${domain}.zono.cc/`

    //console.log("open", url)
    window.location.href = url

  }

  const assetsRow = () => {

    const options = {
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
      items: market.Assets.length,
      lazyLoad: true,
      pagination: "false",
      loop: true,
      center: true,
      dots: true,
      loop: true,
      //margin: 10,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      nav: false,
      navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
    }

    if (market.Assets && market.Assets.length > 1) {
      // return a carousel with the assets
      return (
        <div className="row ">
          <div className="col-12 centered">
            <OwlCarousel nav loop {...options} className="owl-theme owl-carousel-five offers-interested-carousel">
              {market.Assets.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.url} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </OwlCarousel>
          </div>
        </div>
      )
    } else if (market.banner && market.banner != "") {
      // return the business banner
      return (
        <div className="row logo-row">
          <div className="col centered"><img src={market.banner} style={{
            maxHeight: 200,
            minHeight: 100,
            maxWidth: 400,
            objectFit: 'cover'
          }} /></div>
        </div>
      )
    }

    return <></>

  }

  const sectionSelector = () => {
    return (
      <select onChange={(event) => {
        setSection(event.target.value)
      }}>
        <option value=""></option>
        {sections.map((s, index) =>
          <option value={s} key={"section_value_" + index} >{s}</option>
        )}
      </select>
    )
  }

  const categorySelector = () => {
    return (
      <select onChange={(event) => {
        setCategory(event.target.value)
      }}>
        <option value=""></option>
        {categories.map((s, index) =>
          <option value={s} key={"category_value_" + index}  >{s}</option>
        )}
      </select>
    )
  }

  const searchBox = () => {
    return (
      <div className="search_bar_element">
        <input name="search box" id="search_input_box" size="10" onChange={(event) => {
          //console.log("search term", event.target.value)
          setTerm(event.target.value)
        }} />
        <i className="fa fa-search " style={{
          // "padding-left: 5px; vertical-align: bottom; font-size: 20px;"
          paddingLeft: 5,
          verticalAlign: 'bottom',
          fontSize: 20
        }} aria-hidden="true"></i>
      </div>

    )
  }

  const _prefixedColour = (colour) => {
    if (colour.indexOf('#') !== 0) {
      return '#' + colour
    }
    return colour
  }

  function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }

  function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? '#000000'
        : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
  }

  const slugUrl = (uuid) => {
    return `https://${domain}.zono.cc/${uuid}`
  }

  const isEmpty = (str) => {
    return str == null || str == ""
  }

  const facebookButton = (business) => {
    if (isEmpty(business.facebook)) return <></>
    if (business.facebook.startsWith("https")) {
      return (
        <a href={business.facebook}>
          <span className="social-button" >
            <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://facebook.com/" + business.facebook}>
        <span className="social-button" >
          <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const whatsappButton = (business) => {
    if (isEmpty(business.whatsapp)) return <></>

    let phone = business.whatsapp
    if (phone.startsWith('+')) phone = phone.slice(1)

    return (
      <a href={"https://wa.me/" + phone}>
        <span className="social-button" >
          <i className="zmdi zmdi-whatsapp" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const instagramButton = (business) => {
    if (isEmpty(business.instagram)) return <></>
    if (business.instagram.startsWith("https")) {
      return (
        <a href={business.instagram}>
          <span className="social-button" >
            <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://instagram.com/" + business.instagram}>
        <span className="social-button" >
          <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

/*

  const _getBusinessGrid = (businesses) => {
    const breakpointColumnsObj = {
      default: 5,
      1200: 4,
      900: 3,
      700: 2,
      500: 1
    };

    let wwidth = window.innerWidth

    if (!businesses || businesses.length == 0) {
      return (
        <>
          <div className='row justify-content-center' style={{ margin: 0 }}>
            <div className='loader '></div>

          </div>
          <div className='row justify-content-center' style={{ margin: 0 }}>
            <div>
              Este sitio no tiene negocios...
            </div>
          </div>
        </>
      )
    }

    else {

      let entries = filterBusinesses(businesses)
      return (
       <div className="centered">
         <div
          className="businesses-grid"
        >
          {entries.map((business, index) => (
            <BusinessCard business={business} key={`hp_biz_` + index} onSelected={() => {
              //console.log("selected business", business)
              //setSelectedBusiness(business)
              // navigate to the business using the uuid.zono.cc
              window.location.href = `https://${business.uuid}.zono.cc`
            }} />
          ))}
        </div>
       </div>
      )
    }
  }


 const filterRow = () => {
    return (
      <div className="search_bar_row"  >


        {searchBox()}
      </div>
    )
  }

  const twitterButton = (business) => {
    if (isEmpty(business.twitter)) return <></>

    if (business.twitter.startsWith("https")) {
      return (
        <a href={business.twitter}>
          <span className="social-button" >
            <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://twitter.com/" + business.twitter}>
        <span className="social-button" >
          <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const youtubeButton = (business) => {
    if (isEmpty(business.youtube)) return <></>
    if (business.youtube.startsWith("https")) {
      return (
        <a href={business.youtube}>
          <span className="social-button" >
            <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
          </span>
        </a>

      )
    }
    return (
      <a href={"https://youtube.com/" + business.youtube}>
        <span className="social-button" >
          <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const socialButtons = () => {
    return (
      <div>
        {twitterButton(market)}
        {facebookButton(market)}
        {whatsappButton(market)}
        {instagramButton(market)}
        {youtubeButton(market)}
      </div>
    )
  }
 */

  const callButton = (business) => {
    return <a href={callUrl} target="_blank">

      <i className='fa fa-phone fa-2x' style={{
        paddingLeft: 5,
        verticalAlign: 'bottom',
        fontSize: 30
      }}

      ></i>

    </a>
  }

  //console.log("market", market, categories)
  // console.log("businesses", businesses)

  if (market == null) {
    return <></>
  }

  const shuffle = (array) => {
    let currentIndex = array.length;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

      // Pick a remaining element...
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  }


  shuffle(businesses)

  let loc = market.locations[0]

  let mapsUrl = `https://maps.google.com/?ll=${loc.latlng}`
  let whatsappUrl = `https://wa.me/?call=${market.whatsapp}`
  let callUrl = `tel:${market.phone}`

  return (

    <div className="menu-container business-container"  >
      <div className="row logo-row"   >
        <div className="col centered" ><img src={market.photo} /></div>
      </div>

      <div className="centered">
        <div className="social-row  ">
          <a href={mapsUrl} target="_blank">
            <i className='zmdi zmdi-pin' style={{
              paddingLeft: 15,
              verticalAlign: 'bottom',
              fontSize: 30
            }}
            ></i>
          </a>

          {whatsappButton(market)}
          {instagramButton(market)}
          {facebookButton(market)}
          {callButton(market)}

          <div>
            {searchBox()}
          </div>


        </div>
      </div>

      {assetsRow()}

      <div className="row"  >
        <div className="col centered"><span>{market.description}</span></div>
      </div>

      <div className="row"  >
        <div className="col centered category-selector">
          Sector : {sectionSelector()}
        </div>
      </div>


      <div className="row"  >
        <div className="col centered category-selector">
          Categoria: {categorySelector()}
        </div>
      </div>

      {_getMasonryGrid(businesses)}

      {market.Links && market.Links.map((m) => {

        return (

          <div className="menu-link-row " key={`menu_${m.id}`} >
            <div></div>
            <a href={m.link}>

              <h2><div className="button centered v-centered br-15 styled-button">{m.title}</div></h2>

            </a>
            <div></div>
          </div>

        )
      })}

      <div className="powered-element">

        <div className="row  powered-row">
          <div className="col centered"><span>Powered By</span></div>
        </div>

        <div className="row logo-row">
          <a href="https://zono.cc" target="blank">
            <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
          </a>
        </div>
      </div>


    </div>
  )

}

MarketPage.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired,
}


export default MarketPage
